"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Total = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
require("./total.scss");
const className = 'pagination-configuration-text';
const Total = (props) => {
    if (props.total === 0)
        return null;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/PaginationConfiguration:Total', defaultMessage: '{from} - {to} of {total}', values: {
                from: props.pagination.page * props.pagination.pageSize + 1,
                to: props.pagination.page * props.pagination.pageSize + props.pageTotal,
                total: props.total,
            } })));
};
exports.Total = Total;
//# sourceMappingURL=Total.js.map